import styled from '@emotion/styled'
import { withClass, createPropFilter } from 'common/emotion'

import { calcRem } from 'component-library/__styling/style-functions'
import { colors, metrics } from 'component-library/__styling/settings'
import { conditionalStyles } from 'component-library/__styling/conditional-styles'

import { WebLink, WebLinkProps } from 'common/navigation/web-link'

import { styledHeadlineTextClassName } from 'component-library/cards/CardText/CardText.styled'

import { cardInteractionFocusStylesPerthNow } from 'component-library/cards/CardText/CardTextInteractions.styled'
import { CardHeadline } from 'component-library/cards/CardText/CardHeadline'

const styledHeaderClassName = 'Card-Header'

const cardSpacing = metrics.perthnow.cards.spacing
const textOffset = metrics.perthnow.cards.textOffset

export type StyledHeaderProps = { isLoading: boolean }

export const StyledHeader = withClass(styledHeaderClassName)(
    styled(WebLink, { shouldForwardProp: createPropFilter<WebLinkProps>()(['isLoading']) })<
        StyledHeaderProps
    >(
        {
            color: colors.thewest.greyGorilla,
            fontSize: calcRem(16),
            lineHeight: 1.375,
            display: 'block',
            width: '100%',
            textDecoration: 'none',
            ...cardInteractionFocusStylesPerthNow,
        },
        (props: StyledHeaderProps) => ({
            ...conditionalStyles(props.isLoading, {
                cursor: 'default',
            }),
        })
    )
)

export const StyledHeadline = styled(CardHeadline)(
    {
        display: 'block',
        margin: `0 0 ${calcRem(cardSpacing - textOffset)} 0`, // 12 - 5
        flex: '0 0 100%',
        alignSelf: 'flex-start',

        [`& .${styledHeadlineTextClassName}`]: {
            display: 'block',
            transform: `translateY(-${calcRem(textOffset)})`, // offset for font alignment
        },
    },
    ({ theme }) => ({
        fontFamily: theme.fonts.heading,
    })
)
